import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import {
  FulfillmentGroupData,
  FulfillmentGroupPickStatus,
} from "@redotech/redo-fulfillment-group-common/fulfillment-group";

const pickStatusBadgeText: Record<FulfillmentGroupPickStatus, string> = {
  [FulfillmentGroupPickStatus.PICKED]: "Picked",
  [FulfillmentGroupPickStatus.PROBLEM]: "Problem",
  [FulfillmentGroupPickStatus.IN_PROGRESS]: "In Progress",
  [FulfillmentGroupPickStatus.HANDED_OFF]: "Handed off",
};

export const PickStatusCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Pick status",
    cell: (row) => {
      if (!row.pickStatus || !(row.pickStatus in pickStatusBadgeText)) {
        return "-";
      }
      return pickStatusBadgeText[row.pickStatus];
    },
  };
